"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Card", {
    enumerable: true,
    get: function() {
        return Card;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _Theme = require("../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const Card = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { children, ...props } = param;
    const { colors } = (0, _Theme.useTheme)();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        ...props,
        ref: ref,
        className: _style.default.dynamic([
            [
                "81dbf332f0409634",
                [
                    colors.white
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "")
    }, children), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "81dbf332f0409634",
        dynamic: [
            colors.white
        ]
    }, "div.__jsx-style-dynamic-selector{-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;background-color:".concat(colors.white, ";overflow:auto}")));
});
Card.displayName = "Card";

//# sourceMappingURL=Card.js.map